{
  "AUTOMATION": {
    "HEADER": "الأتمتة",
    "DESCRIPTION": "ويمكن للأتمتة أن تحل محل وتبسط العمليات القائمة التي تتطلب جهداً يدوياً، مثل إضافة تسميات وتعيين المحادثات إلى أنسب وكيل. ويسمح ذلك للفريق بالتركيز على مواطن قوتهم مع تقليل الوقت الذي يقضيه في المهام الروتينية.",
    "LEARN_MORE": "تعلم المزيد عن الأتمتة",
    "HEADER_BTN_TXT": "إضافة قاعدة أتمتة",
    "LOADING": "جلب قواعد الأتمتة",
    "ADD": {
      "TITLE": "إضافة قاعدة أتمتة",
      "SUBMIT": "إنشاء",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "FORM": {
        "NAME": {
          "LABEL": "اسم القاعدة",
          "PLACEHOLDER": "أدخل اسم القاعدة",
          "ERROR": "الاسم مطلوب"
        },
        "DESC": {
          "LABEL": "الوصف",
          "PLACEHOLDER": "ادخل وصف القاعدة",
          "ERROR": "الوصف مطلوب"
        },
        "EVENT": {
          "LABEL": "الحدث",
          "PLACEHOLDER": "الرجاء اختيار واحد",
          "ERROR": "الحدث مطلوب"
        },
        "PHASE": {
          "LABEL": "المرحلة"
        },
        "ORDER": {
          "LABEL": "الترتيب",
          "ERROR": "الترتيب مطلوب"
        },
        "CONDITIONS": {
          "LABEL": "الشروط"
        },
        "ACTIONS": {
          "LABEL": "الإجراءات"
        }
      },
      "CONDITION_BUTTON_LABEL": "إضافة شرط",
      "ACTION_BUTTON_LABEL": "إضافة إجراء",
      "API": {
        "SUCCESS_MESSAGE": "تمت إضافة قاعدة الأتمتة بنجاح",
        "ERROR_MESSAGE": "تعذر إنشاء قاعدة أتمتة ، يرجى المحاولة مرة أخرى لاحقاً"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "المرحلة",
        "ORDER": "الترتيب",
        "NAME": "الاسم",
        "DESCRIPTION": "الوصف",
        "ACTIVE": "مفعل",
        "CREATED_ON": "تم إنشاؤها في",
        "WAIT": "الانتظار"
      },
      "404": "لم يتم العثور على قواعد أتمتة",
      "TABS": {
        "ALL": "الكل",
        "INSTANT": "عند الحدث",
        "DELAYED": "بعد مهلة"
      },
      "WAITS": "ينتظر {duration}"
    },
    "DELETE": {
      "TITLE": "حذف قاعدة الأتمتة",
      "SUBMIT": "حذف",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "CONFIRM": {
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد من الحذف ",
        "YES": "نعم، احذف ",
        "NO": "لا، احتفظ "
      },
      "API": {
        "SUCCESS_MESSAGE": "تم حذف قاعدة الأتمتة بنجاح",
        "ERROR_MESSAGE": "تعذر حذف قاعدة الأتمتة، يرجى المحاولة مرة أخرى لاحقاً"
      }
    },
    "EDIT": {
      "TITLE": "تعديل قاعدة الأتمتة",
      "SUBMIT": "تحديث",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث قاعدة الأتمتة بنجاح",
        "ERROR_MESSAGE": "تعذر تحديث قاعدة الأتمتة، الرجاء المحاولة مرة أخرى في وقت لاحق"
      }
    },
    "CLONE": {
      "TOOLTIP": "نسخ",
      "API": {
        "SUCCESS_MESSAGE": "تم نسخ الأتمتة بنجاح",
        "ERROR_MESSAGE": "تعذر استنساخ قاعدة الأتمتة، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "FORM": {
      "EDIT": "تعديل",
      "CREATE": "إنشاء",
      "DELETE": "حذف",
      "CANCEL": "إلغاء",
      "RESET_MESSAGE": "تغيير نوع الحدث سوف يعيد تعيين الشروط والأحداث التي أضفتها أدناه"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "يجب أن يكون لديك على الأقل شرط واحد للحفظ",
      "CONTACT_CUSTOM_ATTR_LABEL": "سمة مخصصة لجهة اتصال",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "سمة مخصصة للمحادثة"
    },
    "ACTION": {
      "DELETE_MESSAGE": "يجب أن يكون لديك على الأقل شرط واحد للحفظ",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "اكتب رسالتك هنا",
      "TEAM_DROPDOWN_PLACEHOLDER": "اختيار فريق",
      "EMAIL_INPUT_PLACEHOLDER": "أدخل البريد الإلكتروني",
      "URL_INPUT_PLACEHOLDER": "أدخل رابط",
      "SENDER_DROPDOWN_PLACEHOLDER": "اختر صندوق البريد الإلكتروني وعنوان المرسل",
      "SUBJECT_INPUT_PLACEHOLDER": "موضوع البريد الإلكتروني",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "اختر قناة الرسائل النصية SMS للإرسال منها",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "أدخل نص الرسالة SMS",
      "SMS_COUNTER": "{length}/{limit} حرفًا، {segments} رسالة SMS (قبل تعبئة المتغيرات)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "تفعيل قاعدة الأتمتة",
      "DEACTIVATION_TITLE": "تعطيل قاعدة الأتمتة",
      "ACTIVATION_DESCRIPTION": "سيؤدي هذا الإجراء إلى تنشيط قاعدة الأتمتة '{automationName}'. هل أنت متأكد من أنك تريد المتابعة؟",
      "DEACTIVATION_DESCRIPTION": "سيؤدي هذا الإجراء إلى إلغاء تنشيط قاعدة الأتمتة '{automationName}'. هل أنت متأكد من أنك تريد المتابعة؟",
      "ACTIVATION_SUCCESFUL": "تم تفعيل قاعدة الأتمتة بنجاح",
      "DEACTIVATION_SUCCESFUL": "تم تعطيل قاعدة الأتمتة بنجاح",
      "ACTIVATION_ERROR": "تعذر تنشيط قاعدة الأتمتة، الرجاء المحاولة مرة أخرى لاحقاً",
      "DEACTIVATION_ERROR": "تعذر إلغاء تنشيط قاعدة الأتمتة، الرجاء المحاولة مرة أخرى لاحقاً",
      "CONFIRMATION_LABEL": "نعم",
      "CANCEL_LABEL": "لا"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "تعذر تحميل المرفق، الرجاء المحاولة مرة أخرى",
      "LABEL_IDLE": "ارفع المرفق",
      "LABEL_UPLOADING": "جاري الرفع...",
      "LABEL_UPLOADED": "تم الرفع بنجاح",
      "LABEL_UPLOAD_FAILED": "فشل الرفع"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "مفتاح الخاصية مطلوب",
      "FILTER_OPERATOR_REQUIRED": "عامل التصفية مطلوب",
      "VALUE_REQUIRED": "القيمة مطلوبة",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "القيمة يجب أن تكون بين 1 و 998",
      "ACTION_PARAMETERS_REQUIRED": "معلمات الإجراء مطلوبة",
      "ATLEAST_ONE_CONDITION_REQUIRED": "شرط واحد على الأقل مطلوب",
      "ATLEAST_ONE_ACTION_REQUIRED": "إجراء واحد على الأقل مطلوب"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "يعمل هذا الإجراء فقط عندما تكون مرحلة القاعدة مضبوطة على 'قبل الوسم'.",
      "SKIP_AUTO_LABELING": "يعمل هذا الإجراء فقط عندما تكون مرحلة القاعدة مضبوطة على 'قبل الوسم'.",
      "MOVE_CONVERSATION_TO_INBOX": "يمكن نقل محادثات البريد الإلكتروني ودردشة الويب فقط إلى قناة بريد إلكتروني، ودردشة الويب فقط إذا كان لدى جهة الاتصال عنوان بريد إلكتروني. وفي غير ذلك تبقى المحادثة في مكانها وتُضاف ملاحظة خاصة بدلاً من ذلك.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "تبدأ محادثة جديدة مع جهة الاتصال في صندوق البريد الإلكتروني المحدد، وترسل إليها الرسالة عبر البريد الإلكتروني، ثم تحلّ المحادثة. يحدث ذلك في كل مرة يتم فيها تشغيل القاعدة. إذا لم يكن لدى جهة الاتصال عنوان بريد إلكتروني، فلن يُرسل أي شيء وستُضاف ملاحظة خاصة بدلاً من ذلك.",
      "SEND_SMS_IN_NEW_CONVERSATION": "تبدأ محادثة جديدة مع جهة الاتصال في قناة SMS المحددة، وترسل إليها الرسالة عبر SMS، ثم تحلّ المحادثة. يحدث ذلك في كل مرة يتم فيها تشغيل القاعدة. الرسالة نص عادي بدون مرفقات. إذا لم يكن لدى جهة الاتصال رقم هاتف، فلن يُرسل أي شيء وستُضاف ملاحظة خاصة بدلاً من ذلك."
    },
    "NOTICES": {
      "AI_PROMPT": "يتم احتساب رسوم على كل عملية تقييم على حدة.",
      "INCOMING_MESSAGES_COUNT": "يشير هذا إلى عدد الرسائل الواردة في المحادثة.",
      "OUTGOING_MESSAGES_COUNT": "يشير هذا إلى عدد الرسائل الصادرة في المحادثة."
    },
    "PHASE": {
      "BEFORE_LABELING": "قبل الوسم",
      "AFTER_LABELING": "بعد الوسم"
    },
    "NONE_OPTION": "لا شيء",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "نعم",
      "NO": "لا"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "رسالة Instagram المباشرة",
      "FACEBOOK_COMMENT": "تعليق Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "إنشاء المحادثة",
      "CONVERSATION_UPDATED": "تحديث المحادثة",
      "MESSAGE_CREATED": "إنشاء رسالة",
      "CONVERSATION_OPENED": "فتح المحادثة",
      "CONVERSATION_RESOLVED": "تم حل المحادثة",
      "PHONE_CALL_FINISHED": "انتهاء المكالمة"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "تعيين وكيل",
      "ASSIGN_TEAM": "تعيين فريق",
      "ADD_LABEL": "إضافة وسم",
      "REMOVE_LABEL": "إزالة وسم",
      "SEND_EMAIL_TO_TEAM": "إرسال بريد إلكتروني إلى الفريق",
      "SEND_EMAIL_TRANSCRIPT": "إرسال نص المحادثة عبر البريد الإلكتروني",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "إرسال نص محادثة مفصل عبر البريد الإلكتروني",
      "MUTE_CONVERSATION": "كتم صوت المحادثة",
      "SNOOZE_CONVERSATION": "تأجيل المحادثة",
      "RESOLVE_CONVERSATION": "حل المحادثة",
      "OPEN_CONVERSATION": "فتح المحادثة",
      "SEND_WEBHOOK_EVENT": "إرسال حدث Webhook",
      "SEND_ATTACHMENT": "إرسال مرفق",
      "SEND_MESSAGE": "إرسال رسالة",
      "ADD_NOTE": "إضافة ملاحظة",
      "CHANGE_PRIORITY": "تغيير الأولوية",
      "ADD_SLA": "إضافة سياسة مستوى الخدمة",
      "SKIP_AUTO_PRIORITY": "تخطي الأولوية التلقائية",
      "SKIP_AUTO_LABELING": "تخطي الوسم التلقائي",
      "AUTO_TRANSLATE": "ترجمة الرسالة",
      "AUTO_TRANSLATE_CONVERSATION": "ترجمة المحادثة",
      "MOVE_CONVERSATION_TO_INBOX": "نقل المحادثة إلى قناة تواصل",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "إرسال رسالة في محادثة جديدة",
      "SEND_SMS_IN_NEW_CONVERSATION": "إرسال SMS في محادثة جديدة",
      "STOP_PROCESSING_RULES": "إيقاف معالجة القواعد"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "تصفية بالذكاء الاصطناعي",
      "MESSAGE_TYPE": "نوع الرسالة",
      "MESSAGE_CONTAINS": "محتوى الرسالة",
      "EMAIL": "البريد الإلكتروني لجهة الاتصال",
      "INBOX": "صندوق الوارد",
      "CHANNEL_TYPE": "نوع صندوق الوارد",
      "CONVERSATION_LANGUAGE": "لغة المحادثة",
      "PHONE_NUMBER": "رقم الهاتف",
      "STATUS": "الحالة",
      "BROWSER_LANGUAGE": "لغة المتصفح",
      "MAIL_SUBJECT": "موضوع البريد الإلكتروني",
      "COUNTRY_NAME": "الدولة",
      "MARKETPLACE_COUNTRY": "بلد السوق الإلكتروني",
      "REFERER_LINK": "رابط المرجع",
      "ASSIGNEE_NAME": "المكلَّف",
      "TEAM_NAME": "الفريق",
      "PRIORITY": "الأولوية",
      "CALL_DIRECTION": "اتجاه المكالمة",
      "MISSED_CALL": "مكالمة فائتة",
      "MISSED_CALL_COUNT": "عدد المكالمات الفائتة",
      "MESSAGE_SOURCE_TYPE": "نوع مصدر الرسالة",
      "INCOMING_MESSAGE_COUNT": "عدد الرسائل الواردة",
      "OUTGOING_MESSAGE_COUNT": "عدد الرسائل الصادرة",
      "LABEL": "الوسم",
      "EMAIL_RECIPIENTS": "مستلم البريد الإلكتروني",
      "EMAIL_AUTO_REPLY": "البريد الإلكتروني رد آلي",
      "ATTACHMENT_EXTENSION": "امتداد المرفق",
      "EXTENSION": "التحويلة التي تم الاتصال بها",
      "WORKING_HOURS": "ضمن ساعات العمل",
      "AGENT_REPLIED": "رد موظف منذ تغيير الحالة"
    },
    "WAIT": {
      "RUN_LABEL": "تشغيل الإجراءات",
      "INSTANT": "عند الحدث",
      "DELAYED": "بعد مهلة",
      "TRIGGER_LABEL": "الانتظار حتى",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "تبقى المحادثة في حالة معينة",
        "CUSTOMER_UNRESPONSIVE": "العميل لا يرد على الموظف",
        "AGENT_UNRESPONSIVE": "العميل لا يتلقى ردًا من الموظف"
      },
      "STATUS_LABEL": "الحالة",
      "STATUSES": {
        "OPEN": "مفتوحة",
        "PENDING": "معلقة",
        "SNOOZED": "مؤجلة",
        "RESOLVED": "تم حلها"
      },
      "DELAY_LABEL": "مدة الانتظار",
      "DELAY_ERROR": "أدخل مدة انتظار بين دقيقة واحدة و30 يومًا",
      "DURATION": {
        "MINUTES": "{count} دقيقة",
        "HOURS": "{count} ساعة",
        "DAYS": "{count} يوم"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "تعمل الإجراءات عندما تبقى المحادثة بحالة {status} لمدة {duration}. تغيير الحالة قبل ذلك يلغيها. يتم التحقق من الوسوم وساعات العمل وردود الموظفين عند انتهاء الانتظار.",
        "CUSTOMER_UNRESPONSIVE": "تعمل الإجراءات عندما لا يرد العميل لمدة {duration} بعد رسالة الموظف. رد العميل يلغيها، ورسالة جديدة من الموظف تعيد بدء الانتظار.",
        "AGENT_UNRESPONSIVE": "تعمل الإجراءات عندما ينتظر العميل {duration} دون رد من الموظف. رد الموظف يلغيها."
      }
    }
  }
}
